import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const KegiatanOne = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [judul, setJudul] = useState("");
  const [deskripsi, setDeskripsi] = useState("");
  const [tanggal, setTanggal] = useState("");
  const [link, setLink] = useState("");

  const [newFiles, setNewFiles] = useState([]);
  const [preview, setPreview] = useState([]);

  useEffect(() => {
    fetchKegiatan();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchKegiatan = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/kegiatan/${id}`
      );
      const kegiatan = res.data;
      setData(kegiatan);
      setJudul(kegiatan.judul);
      setDeskripsi(kegiatan.deskripsi);
      setTanggal(kegiatan.tanggal?.split("T")[0]);
      setLink(kegiatan.link || "");
    } catch (err) {
      toast.error("Gagal mengambil data kegiatan.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setNewFiles([...newFiles, ...files]);
    setPreview([
      ...preview,
      ...files.map((file) => ({ file, url: URL.createObjectURL(file) })),
    ]);
  };

  const handleRemovePreview = (index) => {
    const updatedFiles = [...newFiles];
    updatedFiles.splice(index, 1);
    const updatedPreview = [...preview];
    URL.revokeObjectURL(updatedPreview[index].url);
    updatedPreview.splice(index, 1);
    setNewFiles(updatedFiles);
    setPreview(updatedPreview);
  };

  const handleDeleteMedia = async (fileId) => {
    if (!window.confirm("Yakin ingin menghapus media ini?")) return;

    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}api/kegiatan/${id}/media/${fileId}`
      );
      toast.success("Media berhasil dihapus");
      fetchKegiatan();
    } catch (err) {
      toast.error("Gagal menghapus media.");
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm("Yakin ingin menghapus seluruh kegiatan ini?")) return;

    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}api/kegiatan/${id}`);
      toast.success("Kegiatan berhasil dihapus");
      navigate("/kegiatan");
    } catch (err) {
      toast.error("Gagal menghapus kegiatan.");
    }
  };

  const handleUpdate = async () => {
    const formData = new FormData();
    formData.append("judul", judul);
    formData.append("deskripsi", deskripsi);
    formData.append("tanggal", tanggal);
    formData.append("link", link);
    newFiles.forEach((file) => formData.append("files", file));

    try {
      setSaving(true);
      toast.info("Menyimpan perubahan...", {
        autoClose: false,
        toastId: "saving",
      });

      await axios.put(
        `${process.env.REACT_APP_API_URL}api/kegiatan/${id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      toast.dismiss("saving");
      toast.success("Perubahan berhasil disimpan!");
      setNewFiles([]);
      setPreview([]);
      fetchKegiatan();
    } catch (err) {
      toast.dismiss("saving");
      toast.error("Gagal menyimpan perubahan.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <p className="text-center mt-10 text-gray-500">Memuat...</p>;
  }

  if (!data) {
    return (
      <p className="text-center mt-10 text-red-500">Data tidak ditemukan.</p>
    );
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <ToastContainer />
      <h2 className="text-2xl font-bold mb-4">Edit Kegiatan</h2>

      <div className="space-y-3 mb-6">
        <div>
          <label className="block font-medium">Judul:</label>
          <input
            type="text"
            value={judul}
            onChange={(e) => setJudul(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block font-medium">Deskripsi:</label>
          <textarea
            value={deskripsi}
            onChange={(e) => setDeskripsi(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block font-medium">Tanggal:</label>
          <input
            type="date"
            value={tanggal}
            onChange={(e) => setTanggal(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        <div>
          <label className="block font-medium">Link (opsional):</label>
          <input
            type="text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            className="w-full border rounded px-3 py-2"
          />
        </div>
      </div>

      {/* Media lama */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
        {data.media.map((m) => (
          <div key={m.fileId} className="relative border rounded shadow">
            {m.mimetype.startsWith("image") ? (
              <img
                src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${m.filename}`}
                alt="media"
                className="w-full h-48 object-cover rounded-t"
              />
            ) : (
              <video
                controls
                className="w-full h-48 bg-black rounded-t"
                src={`${process.env.REACT_APP_API_URL}api/kegiatan/media/${m.filename}`}
              />
            )}
            <button
              onClick={() => handleDeleteMedia(m.fileId)}
              className="absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded text-sm"
            >
              Hapus
            </button>
          </div>
        ))}
      </div>

      {/* Upload baru */}
      <div className="mb-6">
        <label className="block font-medium mb-1">
          Upload Tambahan (gambar/video):
        </label>
        <input
          type="file"
          accept="image/*,video/mp4"
          multiple
          onChange={handleFileChange}
          className="mb-4"
        />

        {preview.length > 0 && (
          <div className="grid grid-cols-2 gap-4">
            {preview.map((item, idx) => (
              <div key={idx} className="relative border rounded shadow">
                {item.file.type.startsWith("image") ? (
                  <img
                    src={item.url}
                    alt="preview"
                    className="w-full h-48 object-cover rounded-t"
                  />
                ) : (
                  <video
                    src={item.url}
                    controls
                    className="w-full h-48 bg-black rounded-t"
                  />
                )}
                <button
                  onClick={() => handleRemovePreview(idx)}
                  className="absolute top-2 right-2 bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-sm"
                >
                  Hapus
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="flex gap-4">
        <button
          onClick={handleUpdate}
          disabled={saving}
          className={`px-5 py-2 rounded text-white ${
            saving
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {saving ? "Menyimpan..." : "Simpan Perubahan"}
        </button>

        <button
          onClick={handleDeleteAll}
          className="bg-red-700 hover:bg-red-800 text-white px-5 py-2 rounded"
        >
          Hapus Seluruh Kegiatan
        </button>
      </div>
    </div>
  );
};

export default KegiatanOne;
